// extracted by mini-css-extract-plugin
module.exports = {"overlay":"index_overlay__1DdNo","white":"index_white__3WeJu"};